window.addEventListener("load", function () {
  const cryoServices = document.querySelectorAll(".cryoServices");
  const cryoAddons = document.querySelectorAll(".cryoAddons");

  function initSwiper(el) {
    if (el.swiper) return; // already initialized

    const nextBtn = el.querySelector(".swiper-button-next");
    const prevBtn = el.querySelector(".swiper-button-prev");
    
    const swiperConfig = {
      slidesPerView: 3,
      spaceBetween: 30,
      direction: "horizontal",
      observer: true,
      observeParents: true,
      breakpoints: {
        280: {
          slidesPerView: "auto",
          spaceBetween: 0,
          direction: "vertical",
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
          direction: "horizontal",
        },
      },
    };

    // Only add navigation if buttons exist
    if (nextBtn && prevBtn) {
      swiperConfig.navigation = {
        nextEl: nextBtn,
        prevEl: prevBtn,
      };
    }

    const swiper = new Swiper(el, swiperConfig);

    // Swiper automatically attaches itself to el.swiper
  }

  function destroySwiper(el) {
    if (el.swiper) {
      el.swiper.destroy(true, true);
    }
  }

  function handleResize() {
    const isDesktop = window.innerWidth >= 992;

    [...cryoServices, ...cryoAddons].forEach((el) => {
      if (isDesktop) {
        initSwiper(el);
      } else {
        destroySwiper(el);
      }
    });
  }

  // Initial setup
  handleResize();

  // Recalculate swiper when tab becomes visible
  document.querySelectorAll('[data-bs-toggle="pill"]').forEach((tabBtn) => {
    tabBtn.addEventListener("shown.bs.tab", function () {
      setTimeout(() => {
        [...cryoServices, ...cryoAddons].forEach((el) => {
          if (el.swiper) el.swiper.update();
        });
      }, 100);
    });
  });

  // Handle responsive behavior on resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 300);
  });
});
